<template>
    <modal
        no-fade="true"
        :title="$t(title)"
        :id="id"
        :actionButtons="true"
        size="full"
        :closeButton="false"
        @shown="shown"
    >
        <!-- <template slot="modal-header">
            <span></span>
        </template>-->

        <ul class="nav nav-tabs mb-2">
            <li class="nav-item">
                <a href="#" @click.prevent="tab ='map'" class="nav-link" :class="{active:tab == 'map'}">{{ $t('Map') }}</a>
            </li>
            <li class="nav-item">
                <a
                    href="#"
                    @click.prevent="tab ='details'"
                    class="nav-link"
                    :class="{active:tab == 'details'}"
                >{{ $t('Details') }}</a>
            </li>
            <li class="ml-auto">
                <p class="navbar-text">
                    <span>{{ customer.last_name }} {{ customer.first_name }}</span>
                    <br>
                    <span class="small text-muted" v-if="customer.birth_date">
                        {{ $tc('y.o.', age) }}
                    </span>
                </p>
            </li>
        </ul>
        <div>
            <div v-if="tab =='details'">
                <div class="row">
                    <div class="col-4">
                        <b-form-group :label="$t('Bite')">
                            <b-form-radio
                                v-model="exam.bite"
                                name="exam-bite"
                                value="Orthognathic"
                            >{{ $t('Orthognathic') }}
                            </b-form-radio>
                            <b-form-radio v-model="exam.bite" name="exam-bite" value="Progenic">{{ $t('Progenic') }}</b-form-radio>
                            <b-form-radio v-model="exam.bite" name="exam-bite" value="Straight">{{ $t('Straight') }}</b-form-radio>
                            <b-form-radio v-model="exam.bite" name="exam-bite" value="Biprognatic">{{ $t('Biprognatic') }}</b-form-radio>
                            <b-form-radio v-model="exam.bite" name="exam-bite" value="Overjet">{{ $t('Overjet') }}</b-form-radio>
                            <b-form-radio v-model="exam.bite" name="exam-bite" value="Open bite">{{ $t('Open bite') }}</b-form-radio>
                            <b-form-radio v-model="exam.bite" name="exam-bite" value="Crossbite">{{ $t('Crossbite') }}</b-form-radio>
                            <b-form-radio v-model="exam.bite" name="exam-bite" value="Overbite">{{ $t('Overbite') }}</b-form-radio>
                        </b-form-group>
                    </div>
                    <div class="col-4">
                        <b-form-group :label="$t('Oral Hygiene Index GV')">
                            <b-form-input class="col-2" v-model="exam.OralHygieneIndexGV"/>
                        </b-form-group>
                        <div class="card">
                            <div class="card-body p-3 small">
                                0-0,6 &nbsp;&nbsp; – {{ $t('Normal') }};
                                <br/>
                                0,7-1,5 – {{ $t('Satisfactory') }};
                                <br/>
                                1,6-2,5 – {{ $t('Unsatisfactory') }};
                                <br/>
                                > 2,6 &nbsp;&nbsp;&nbsp; – {{ $t('Bad') }};
                                <br/>
                            </div>
                        </div>
                        <b-form-group :label="$t('Oral Hygiene Index')">
                            <b-form-input class="col-2" v-model="exam.OralHygieneIndex"/>
                        </b-form-group>
                        <div class="card">
                            <div class="card-body p-3 small">
                                1,0-1,5 – {{ $t('Normal') }};
                                <br/>
                                1,6-2,0 – {{ $t('Satisfactory') }};
                                <br/>
                                2,1-2,5 – {{ $t('Unsatisfactory') }};
                                <br/>
                                2,6-3,4 – {{ $t('Bad') }};
                                <br/>
                                3,5-5,0 – {{ $t('Very Bad') }};
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <b-form-group :label="$t('Objectivly details')" class="small text-muted">
                            <b-form-textarea
                                id="textarea"
                                class="small"
                                rows="3"
                                max-rows="6"
                                v-model="exam.objectivly"
                            ></b-form-textarea>
                        </b-form-group>
                        <b-form-group :label="$t('State of oral mucosa')" class="small text-muted">
                            <b-form-textarea
                                id="textarea"
                                class="small"
                                rows="3"
                                max-rows="6"
                                v-model="exam.OralMucosa"
                            ></b-form-textarea>
                        </b-form-group>
                        <b-form-group :label="$t('X-Ray and Lab examination results')" class="small text-muted">
                            <b-form-textarea id="textarea" v-model="exam.xRayAndLab" rows="3" max-rows="6"></b-form-textarea>
                        </b-form-group>
                    </div>
                </div>
            </div>
            <div v-if="tab==='map'" class="row">
                <div class="col-12">
                    <div class="row no-gutters">
                        <div class="col"></div>
                        <div class="col-auto">
                            <custom-switch v-model="kid" :title="$t('Baby map')"
                                           id="kidOrNotFast" class="p-2"/>
                        </div>
                    </div>
                </div>
                <div class="col-12" v-if="!newLayout">
                    <fast-map v-model="exam.map" :kid="kid"/>
                </div>

                <div class="col-12" v-else>
                    <tooth-exam-map v-model="exam.map" :kid="kid"/>
                </div>

            </div>
        </div>
        <template slot="modal-footer">
            <div class="card-footer" style="display:block">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-auto">
                        <b-checkbox class="mr-2" style="display: inline-block" v-model="generatePlan" id="generatePlan">{{ $t('Generate and save plan') }}</b-checkbox>
                        <button type="button" @click="close" class="btn btn-white">{{ $t('Close') }}</button>
                        <button type="button" @click="saveAction" class="btn btn-primary ml-2">{{ $t('Save') }}</button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>


import Modal from "@/components/Modal.vue";
import CustomSwitch from "@/components/CustomSwitch.vue";
import {modalMixins} from '@/mixins/modal.js'
import {mapActions, mapGetters} from 'vuex';
import FastMap from '@/components/Teeth/Fast.vue';
import TeethExamMap from "./TeethExamMap";

export default {
    props: ['id', 'customerId'],
    mixins: [modalMixins],
    components: {
        ToothExamMap: TeethExamMap,
        Modal,
        FastMap,
        CustomSwitch
    },
    data() {
        return {
            title: 'Initial examination',
            generatePlan: false,
            kid: false,
            exam: {
                bite: null,
                OralHygieneIndex: null,
                OralHygieneIndexGV: null,
                OralMucosa: null,
                xRayAndLab: null,
                map: [],
                objectivly: null,
            },
            tab: 'map',
            toothCondition: [
                'Root',
                'Implant',
                'Artificial tooth',
                'Crown',
                'Depulped',
                'Plombed'
            ]
        }
    },

    computed: {
        ...mapGetters('customers', ['get']),
        ...mapGetters('configurator', { findConfsInStore: 'find' }),
        customer() {
            return this.get(this.customerId);
        },
        age() {
            return this.$moment().diff(this.customer.birth_date, 'years');
        },
        newLayout() {
            return this.$settings.newElementaryExam;
        },
    },
    methods: {
        ...mapActions('customers', ['patch']),
        ...mapActions('configurator', { fetchConfs: 'find' }),
        ...mapActions('presets', { fetchPresets: 'find' }),
        ...mapActions('treatment-plan', ['create']),

        savePlan() {
            let plan = this.map2plan(this.exam.map);
            plan.customerId = this.customerId;
            this.create(plan)
        },

        unfoldTreatments(treatments) {
            let result = []
            treatments.forEach(item => {
                if (item.treatment) {
                    result.push({
                        stage: item.stage,
                        color: item.color,
                        treatment: item.treatment
                    })
                }
                if (item.preset) {
                    item.preset.treatments.forEach(el => {
                        result.push({
                            stage: item.stage,
                            color: item.color,
                            treatment: el
                        })
                    })
                }
            })
            return result
        },

        groupOptions(options) {
            options = options.map(item => {
                item.treatments = item.treatments.filter(el => el.treatmentId || el.presetId)
                return item
            }).filter(el => !!el.treatments.length)
            let groupedByTooth = this.$groupBy(options, el => el.tooth);
            let result = [];
            Object.keys(groupedByTooth).forEach(tooth => {
                let treatPlan = { tooth, stages: [] };
                groupedByTooth[tooth].forEach(el => treatPlan.stages.push(...this.unfoldTreatments(el.treatments)))
                treatPlan.stages.forEach(el => el.treatmentId = el.treatment._id)
                treatPlan.stages = this.$groupBy(treatPlan.stages, el => el.stage)
                result.push(treatPlan);
            })
            return { teeth: result }
        },

        map2plan(value) {
            let mapping = value.filter(el => !!el.option)
            const options = mapping.map(mapItem => {
                const conf = this.findConfsInStore({
                    query: {
                        $or: [
                            { 'options._id': mapItem.option },
                            { _id: mapItem.option }
                        ]
                    }
                }).data[0]
                if (!conf) return null
                if (conf._id === mapItem.option) {
                    return { tooth: mapItem.tooth, treatments: conf.treatments }
                } else {
                    const option = conf.options.find(el => el._id === mapItem.option)
                    return { tooth: mapItem.tooth, ...option }
                }
            })
            return this.groupOptions(options.filter(el => !!el))
        },

        shown() {
            let examDefaults = {
                bite: "Orthognathic",
                OralHygieneIndex: "2.0",
                OralHygieneIndexGV: "1.5",
                xRayAndLab: "",
                OralMucosa: this.$t('examDefaults.OralMucosa'),
                objectivly: this.$t('examDefaults.objectivly')
            }
            this.exam = Object.assign(this.exam, examDefaults, this.customer.elementaryExam);
            this.fetchConfs({});
            this.fetchPresets({});
            this.kid = this.age > 0 && this.age <= 7;
        },
        saveAction() {

            let promise = this.patch([this.customerId, { elementaryExam: this.exam }]);
            let successMessage = this.$t('Exam has been saved');
            if (this.generatePlan)
                this.savePlan()

            promise.then(data => {
                this.$toasted.global.success({
                    message: successMessage
                });
                this.close()
            });
        },

        close() {
            this.$root.$emit('bv::hide::modal', this.id);
        }
    }
}
</script>

<style lang="scss">
.bounce-enter-active {
    animation: bounce-in .15s;
}
.bounce-leave-active {
    animation: bounce-in .15s reverse;
}
@keyframes bounce-in {
    0% {
        transform: scale(.3);
    }
    100% {
        transform: scale(1);
    }
}

</style>
